import { render, staticRenderFns } from "./PurchaseOrdersDetail.vue?vue&type=template&id=47abc86a&scoped=true"
import script from "./PurchaseOrdersDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrdersDetail.vue?vue&type=style&index=0&id=47abc86a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abc86a",
  null
  
)

export default component.exports